import React from "react";
import { CheckCircle, Target } from "@phosphor-icons/react";

export default function QuestList({ quests }) {
  if (!quests || quests.length === 0) return null;
  return (
    <section className="bg-white rounded-3xl p-5 shadow-sm mb-5" data-testid="quests-card">
      <div className="flex items-center gap-2 mb-3">
        <Target size={22} weight="duotone" color="#E76F51" />
        <div className="font-outfit font-extrabold text-brand-ink text-base">Bu haftaki görevlerin</div>
      </div>
      <div className="flex flex-col gap-3">
        {quests.map((q) => {
          const pct = Math.min(100, Math.round(((q.progress || 0) / (q.target || 1)) * 100));
          const done = q.done;
          return (
            <div key={q.key} data-testid={`quest-${q.key}`} className={`rounded-2xl p-3 border-2 ${done ? "border-good bg-good-bg" : "border-transparent bg-brand-paperAlt"}`}>
              <div className="flex items-start gap-2">
                <div className="mt-0.5">
                  {done ? <CheckCircle size={20} weight="fill" color="#2A9D8F" /> :
                    <div className="w-5 h-5 rounded-full border-2 border-brand-ink2/40" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className={`font-outfit font-bold text-sm ${done ? "text-good" : "text-brand-ink"}`}>
                    {q.title}
                  </div>
                  <div className="font-nunito text-xs text-brand-ink2 mt-0.5">{q.desc}</div>
                  <div className="mt-2 flex items-center gap-2">
                    <div className="flex-1 h-1.5 bg-white rounded-full overflow-hidden">
                      <div className="h-full bg-brand-primary rounded-full transition-all" style={{ width: `${pct}%` }} />
                    </div>
                    <span className="text-xs font-nunito font-semibold text-brand-ink2 flex-shrink-0">
                      {q.progress || 0}/{q.target}
                    </span>
                    <span className="text-xs font-nunito font-bold text-brand-ink flex-shrink-0">+{q.xp} XP</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
